/**
 * SEO Configuration for Direct Connect Wales
 *
 * The actual metadata lives in seo.json so it can be shared with the
 * build-time prerender script (scripts/prerender-seo.mjs), which stamps
 * these tags into static per-route HTML for search engine crawlers.
 * Edit seo.json to change titles/descriptions — this file only adds types.
 */
import seoData from './seo.json'

export interface PageSEO {
  title: string
  description: string
  keywords?: string
  url: string
  noindex?: boolean
}

export const siteConfig = {
  name: seoData.site.name,
  url: seoData.site.url,
  defaultImage: seoData.site.defaultImage,
  defaultDescription: seoData.site.defaultDescription,
  defaultKeywords: seoData.site.defaultKeywords,
}

export const seoConfig = seoData.pages as Record<keyof typeof seoData.pages, PageSEO>
